import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { utils, read } from 'xlsx';

@Component({
  selector: 'app-import-reservation-data',
  templateUrl: './import-reservation-data.component.html',
  styleUrls: ['./import-reservation-data.component.scss'],
  standalone: true,
  imports: [
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatIcon,
    MatDatepickerModule,
    CommonModule,
    MatButtonModule
  ]
})
export class ImportReservationDataComponent implements OnInit {

  reservationDataForm!: FormGroup;

  loading = new BehaviorSubject<boolean>(false);
  organizations: any;
  page = 0;
  tableLength = 0;
  fileName = '';

  reservationTableData: any;
  excelDataJsonObject: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router
  ) { }

  ngOnInit() {
    this.initForms();
  }

  initForms() {
    this.reservationDataForm = this.formBuilder.group({
      organizationId: ['', [Validators.required, Validators.pattern(/[\S]/)]],
      createdDate: [new Date(), Validators.required]
    });
  }

  async onFileSelected(event: any) {
    let file: File = event.target.files[0];
    if (file) {
      this.fileName = file.name;

      let excelFileReader = new FileReader();
      excelFileReader.readAsArrayBuffer(file);
      excelFileReader.onload = (event) => {
        let data = event.target?.result;
        let workbook = read(data, { type: "binary", cellDates: true, dateNF: 'mm/dd/yyyy;@', raw: true });
        let uploadWorksheet = workbook.SheetNames[0];
        this.reservationTableData = utils.sheet_to_json(workbook.Sheets[uploadWorksheet]);
      }
    }
  }

  onReviewReservationDataClick() {
    this.buildReservationData();
  }

  async buildReservationData() {
    let reservationData = {
      organizationId: this.reservationDataForm.get('organizationId')?.value,
      reservationDataJSON: this.reservationTableData,
      createdDate: this.reservationDataForm.get('createdDate')?.value
    }

    this.router.navigate(['reservations/review'], {
      state: {
        organizationId: reservationData.organizationId,
        importData: reservationData.reservationDataJSON,
        createdDate: new Date(reservationData.createdDate).toISOString()
      }
    });
  }
}